import TeamInfo from "../teamInfo";
import { ProcurementFilterModel } from "./ProcurementFilter.model";

export class ProcurementFilter extends ProcurementFilterModel {
    altToApiObject() {
        const filter = this.toApiObject();

        if (!filter.procurement_filter_teams_attributes) {
            filter.procurement_filter_teams_attributes = [];
        }

        this.receivingTeams?.forEach((team: TeamInfo) => {
            if (
                !filter.procurement_filter_teams_attributes?.find(
                    (t: any) => t.team_id === team.id && t.procurement_role === "receiving_team"
                )
            ) {
                filter.procurement_filter_teams_attributes.push({
                    team_id: team.id,
                    procurement_role: "receiving_team",
                });
            }
        });
        this.vendors?.forEach((vendor: TeamInfo) => {
            if (
                !filter.procurement_filter_teams_attributes?.find(
                    (t: any) => t.team_id === vendor.id && t.procurement_role === "vendor"
                )
            ) {
                filter.procurement_filter_teams_attributes.push({
                    team_id: vendor.id,
                    procurement_role: "vendor",
                });
            }
        });
        const receivingTeams = this.receivingTeams || [];
        const vendorTeams = this.vendors || [];
        const allTeams: TeamInfo[] = [...receivingTeams, ...vendorTeams];

        filter.procurement_filter_teams_attributes.forEach((team: any) => {
            if (!allTeams.find((t: TeamInfo) => t.id === team.team_id)) {
                team._destroy = true;
            }
        });

        return { procurement_filter: filter };
    }

    appendedToUrl(url: URL) {
        if (this.textSearch) {
            url.searchParams.set("text_search", this.textSearch);
        }

        if (this.receivingTeams && this.receivingTeams.length > 0) {
            for (const team of this.receivingTeams) {
                url.searchParams.append("teams[]", team.id ? team.id : team);
            }
        }

        if (this.vendors && this.vendors.length > 0) {
            for (const vendorTeam of this.vendors) {
                url.searchParams.append("vendor_teams[]", vendorTeam.id ? vendorTeam.id : vendorTeam);
            }
        }

        if (this.orderStatus && this.orderStatus.length > 0) {
            for (const orderStatus of this.orderStatus || []) {
                url.searchParams.append("order_status[]", orderStatus.toString());
            }
        }

        return url;
    }

    isUnfiltered(): boolean {
        if (this.textSearch && this.textSearch !== "") {
            return false;
        }
        if (this.receivingTeams && this.receivingTeams.length > 0) {
            return false;
        }
        if (this.vendors && this.vendors.length > 0) {
            return false;
        }
        if (this.orderStatus && this.orderStatus.length > 0) {
            return false;
        }
        return true;
    }

    filterCount(): number {
        let count = 0;
        if (this.textSearch && this.textSearch !== "") {
            count += 1;
        }
        if (this.receivingTeams && this.receivingTeams.length > 0) {
            count += this.receivingTeams.length;
        }
        if (this.vendors && this.vendors.length > 0) {
            count += this.vendors.length;
        }
        if (this.orderStatus && this.orderStatus.length > 0) {
            count += this.orderStatus.length;
        }
        return count;
    }

    static blank(projectId: number, timezone: string, userId?: number): ProcurementFilter {
        return ProcurementFilter.fromApiObject(
            {
                id: undefined,
                name: "",
                order_status: [],
                project_id: projectId,
                text_search: "",
                receiving_teams: [],
                vendors: [],
                procurement_filter_teams_attributes: [],
                user_id: userId,
            },
            timezone
        );
    }
}
